<template>
    <div class="real-name-import fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">实名导入</span>
            <el-form inline ref="realNameImportForm" v-model="realNameImportData" class="right themed-form search-form" style="height: auto;line-height: 40px;">
                 <el-form-item>
                    <el-input v-model="realNameImportData.iccidMark" placeholder="ICCID号" class="iccid-width"></el-input>
                </el-form-item>
                <el-form-item>
					<el-date-picker style="width: 126px;" placeholder="导入起始日期" v-model="realNameImportData.startTime" type="date" value-format="yyyy-MM-dd"/>
				</el-form-item>
				<el-form-item>
					<span class="text-color">至</span>
				</el-form-item>
				<el-form-item>
					<el-date-picker style="width: 126px;" placeholder="导入结束日期" v-model="realNameImportData.endTime" type="date" value-format="yyyy-MM-dd"/>
				</el-form-item>
                <el-form-item>
					<el-button icon="el-icon-search" type="primary" class="themed-button" @click="onSearch">查询</el-button>
				</el-form-item>
                <el-form-item>
					<el-button icon="el-icon-circle-plus-outline" type="info" class="themed-button" @click="addByExcel">实名导入</el-button>
				</el-form-item>
                <el-form-item>
					<el-button icon="el-icon-delete" type="warning" class="themed-button" @click="deleteByExcel">批量删除实名导入</el-button>
				</el-form-item>
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                border
                ref="table"
                stripe
                :max-height="maxTableHeight"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                >
                <el-table-column
                    prop="iccidMark"
                    label="ICCID"
                    min-width="20%"
                    >
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="updateTime"
                    label="导入时间"
                    min-width="20%"
                    >
                </el-table-column>
                <el-table-column
                    label="状态"
                    min-width="10%"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==1">成功</span>
                        <span v-else>失败</span>
                    </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="failReason"
                    label="失败原因"
                    min-width="25%"
                    >   
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="createUserName"
                    label="操作人"
                    min-width="15%"
                    >   
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="操作"
                    min-width="10%"
                    >
                    <template slot-scope="scope">
                        <el-button  size="mini" class="themed-button" type="warning" @click="handleDelete(scope.row.id,scope.row.iccidMark)">删 除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="page"  :page-sizes="[5,10,15,50,100,1000]" :page-size="pageSize" style="text-align: left;margin-top: 20px;"
			 background layout="total,sizes,prev, pager, next,jumper" :total="total" @size-change="handleSizeChange" @current-change="onPageChange"></el-pagination>
        </div>

        <el-dialog title="实名导入" :visible.sync="dialogRealnameImportVisible" width="500px" :destroy-on-close='true'>
            <el-form :model="dialogForm"  ref="dialogForm">
                <el-form-item label="请选择excel文件:" :label-width="formLabelWidth">
                    <input class="file-input" type="file" ref='fileInput'/>
                    <div class="mt5">
                            <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="themed-button" type="primary" @click="uploadExcel">导入excel模板</el-button>
                <el-button class="themed-button" type="primary" @click="exportTemplateExcel('shiming.xls')">导出excel模板</el-button>
                <el-button class="themed-button" type="primary" @click="dialogRealnameImportVisible = false">关 闭</el-button>
            </div>
        </el-dialog>

        <el-dialog title="实名导入" :visible.sync="dialogRealnameDeleteVisible" width="500px" :destroy-on-close='true'>
            <el-form :model="dialogDeleteForm"  ref="dialogDeleteForm">
                <el-form-item label="请选择excel文件:" :label-width="formLabelWidth">
                    <input class="file-input" type="file" ref='fileDeleteInput'/>
                    <div class="mt5">
                            <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="themed-button" type="info" @click="uploadDeleteExcel">导入文件</el-button>
                <el-button class="themed-button" type="info" @click="exportTemplateExcel('shiming.xls')">导出excel模板</el-button>
                <el-button class="themed-button" type="primary" @click="dialogRealnameDeleteVisible = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {messageBox,confirmBox} from '@/utils/common.js'
import { realNameImport,realNameAddExcel,realNameDelExcel,realNameDelete} from "@/api/history.js";
import resize from '@/mixins/resize.js'
import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'
export default {
    name:'realNameImport',
    mixins:[resize],
    data(){
        return {
            realNameImportData:{
                isDelete:'2',
                iccidMark:'',
                startTime:'',
                endTime:'',
            },
            tableData:[],
            page:1,
            pageSize:15,
            total:0,
            dialogRealnameImportVisible:false,
            formLabelWidth:'150px',
            dialogForm:{},
            dialogRealnameDeleteVisible:false,
            dialogDeleteForm:{},
        }
    },
    created(){
        this.getRealNameImportList()
    },
    methods:{
        getRealNameImportList(){
            let params = {
                pageSize:this.pageSize,
                pageNo:this.page
            }
            Object.assign(this.realNameImportData,params)
            realNameImport(this.realNameImportData).then(res=>{
                this.tableData=res.rows
                this.total=res.count
            })
        },
        handleSizeChange(size){
            this.pageSize=size
            this.getRealNameImportList()
        },
        onPageChange(page){
            this.page=page
            this.getRealNameImportList()
        },
        onSearch(){
            this.page=1
            this.getRealNameImportList()
        },
        addByExcel(){
            this.dialogRealnameImportVisible=true
        },
        uploadExcel(){
            this.$confirm("确定要导入吗？", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(()=>{
                    let file = this.$refs['fileInput'].files[0];
                    if(file){
                        let fileName = file.name
                        let index = fileName.lastIndexOf(".");
                        if(index < 0 || !(fileName.substring(index + 1, fileName.length)=='xls'|| fileName.substring(index + 1, fileName.length)=='xlsx')){
                            this.$alert('文件格式错误', '提示', {
							    confirmButtonText:'确定',
							});
							return
                        }else if(!!Utils.checkFile(file)){
                      if(Utils.checkFile(file)==1){
                         messageBox(this,'上传文件不能超过20M')
                            return
                      }else if(Utils.checkFile(file)==2){
                          messageBox(this,'上传文件名称长度不能超过36个字符')
                            return
                      }
                }else{
                            let param = new FormData()
                            param.append("fileurl",file)
                            realNameAddExcel(param).then(res=>{
                                  if (res.system_result_key == '0') {
                            // this.$message({
							// 	type: 'success',
							// 	message:'导入成功'
                            // });

                                this.$alert('导入成功', '提示', {
						    confirmButtonText:'确定',
						}).then(()=>{
                             this.getRealNameImportList()
							this.count = 0
							this.dialogForm = {}
                            this.$refs['fileInput'].value = ''
                            this.dialogRealnameImportVisible=false
							this.$router.push('/tob/i_import_list')
						});
                        }else{
                          this.$message({
                                showClose: true,
                                message: res.system_result_message_key,
                                type: 'error'
                            });
                        }
                            })
                        }
                    }else{
                        this.$alert('请选择文件', '提示', {
							    confirmButtonText:'确定',
							});
							return
                    }
                })
        },
        // 导出
        exportTemplateExcel(name){
            exportTemplate({'name':name}).then(res=>{
                const filename = name
				Utils.createDownload(res,filename)
            })
        },
        // 批量删除
        deleteByExcel(){
            this.dialogRealnameDeleteVisible=true
        },
        uploadDeleteExcel(){
            this.$confirm("确定要进行回收吗？", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(()=>{
                    let file = this.$refs['fileDeleteInput'].files[0];
                    if(file){
                        let fileName = file.name
                        let index = fileName.lastIndexOf(".");
                        if(index < 0 || !(fileName.substring(index + 1, fileName.length)=='xls'|| fileName.substring(index + 1, fileName.length)=='xlsx')){
                            this.$alert('文件格式错误', '提示', {
							    confirmButtonText:'确定',
							});
							return
                        }else if(!!Utils.checkFile(file)){
                      if(Utils.checkFile(file)==1){
                         messageBox(this,'上传文件不能超过20M')
                            return
                      }else if(Utils.checkFile(file)==2){
                          messageBox(this,'上传文件名称长度不能超过36个字符')
                            return
                      }
                }else{
                            let param = new FormData()
                            param.append("fileurl",file)
                            realNameDelExcel(param).then(res=>{
                                  if (res.system_result_key == '0') {
                            //  this.$message({
							// 	type: 'success',
							// 	message:'导入成功'
                            // });

                              this.$alert('导入成功', '提示', {
						    confirmButtonText:'确定',
						}).then(()=>{
                             this.getRealNameImportList()
							this.count = 0
							this.dialogDeleteForm = {}
                            this.$refs['fileDeleteInput'].value = ''
                            this.dialogRealnameDeleteVisible=false
							this.$router.push('/tob/i_import_list')
						});
                        }else{
                          this.$message({
                                showClose: true,
                                message: res.system_result_message_key,
                                type: 'error'
                            });
                        }
                            })
                        }
                    }else{
                        this.$alert('请选择文件', '提示', {
							    confirmButtonText:'确定',
							});
							return
                    }
                })
        },
        handleDelete(id,iccid){
            this.$confirm("删除后将不可恢复，确认是否删除?", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(()=>{
                    let params = {
                        'id':id,
                        'iccid':iccid,
                        'pageSize':this.pageSize,
                        'pageNo':this.page
                    }
                    realNameDelete(params).then(res=>{
                        this.$message({
								type: 'success',
								message:'删除成功'
                            });
                         this.getRealNameImportList()
                    })
                })
        },
        
    }
}
</script>
<style>
    
</style>
